/* Medicus: live sentence under the "This is what an awesome 'insert role' looks like" box.
   The customer types the role, this shows the whole sentence beneath it,
   labelled "Your Embroidery Next To The Hand", on two lines: "This is what an awesome" / "<role> looks like".
   Display only. It never changes the value YMQ submits with the order.
   Safe if the customer types the full sentence: the lead-in and the
   trailing "looks like" are stripped before the sentence is rebuilt. */
(function () {
  'use strict';
  var LABEL = /insert role/i;
  var LINE1 = 'This is what an awesome';
  var TAIL = ' looks like';
  var STRIP_LEAD = /^\s*this\s+is\s+what\s+an?\s+(awesome\s+)?/i;
  var STRIP_TAIL = /\s+looks\s+like\s*\.?\s*$/i;

  function role(raw) {
    var v = String(raw || '').replace(/\s+/g, ' ').trim();
    return v.replace(STRIP_LEAD, '').replace(STRIP_TAIL, '').trim();
  }

  function attach(box) {
    var input = box.querySelector('input.ymq-option-text');
    if (!input) return;
    if (box.__mcRole && box.contains(box.__mcRole.el)) return;

    var el = document.createElement('p');
    el.className = 'mc-role-preview';
    el.hidden = true;
    el.setAttribute('aria-live', 'polite');
    var k = document.createElement('span');
    k.className = 'mc-role-preview__k';
    k.textContent = 'Your Embroidery Next To The Hand';
    var t1 = document.createElement('span');
    t1.className = 'mc-role-preview__t';
    t1.textContent = LINE1;
    var t2 = document.createElement('span');
    t2.className = 'mc-role-preview__t';
    el.appendChild(k);
    el.appendChild(t1);
    el.appendChild(t2);

    var anchor = input.closest('.ymq-option-text-input-wrapper') || input;
    anchor.insertAdjacentElement('afterend', el);

    var last = null;
    function render() {
      var w = role(input.value);
      if (w === last) return;
      last = w;
      if (!w) { el.hidden = true; t2.textContent = ''; return; }
      t2.textContent = w + TAIL;
      el.hidden = false;
    }
    input.addEventListener('input', render);
    input.addEventListener('change', render);
    input.addEventListener('keyup', render);
    /* catches values set by script, e.g. the cart "Change options" refill */
    var poll = setInterval(function () {
      if (!document.body.contains(input)) { clearInterval(poll); return; }
      render();
    }, 400);
    box.__mcRole = { el: el };
    render();
  }

  function scan() {
    var boxes = document.querySelectorAll('.ymq-options-box[ymq-option-label]');
    for (var i = 0; i < boxes.length; i++) {
      if (LABEL.test(boxes[i].getAttribute('ymq-option-label') || '')) attach(boxes[i]);
    }
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  function start() {
    scan();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
